import { Box, Button, Paper } from '@mui/material';
import { CheckCircleOutline as CheckIcon, Schedule as ScheduleIcon } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import StatusRenderer from './InvoiceStatusRenderer';
import React from 'react';
import { formatInvoiceDate, formatNumberToCurrency, formatPeriod } from '../../helpers/utils';

const NextInvoiceDetails = ({ tenant }) => {
  const isPending = tenant.nextinvoicestatus === 'Pending Approval';

  const date = formatInvoiceDate(tenant.nextinvoicedate);
  const period = formatPeriod(tenant.nextinvoiceperiodstartdate, tenant.nextinvoiceperiodenddate);

  return (
    <Box display="flex" flexDirection="column" gap={3} mt={1}>
      <Paper
        variant="outlined"
        sx={{
          p: 3,
          borderRadius: 2,
          bgcolor: '#FFF9E6',
          borderColor: '#FFE57F'
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" gap={1}>
            <ScheduleIcon sx={{ color: '#F57C00' }} />
            <Typography variant="h6" color="#E65100" fontWeight="bold">
              Next Invoice
            </Typography>
          </Box>
          <StatusRenderer value={tenant.nextinvoicestatus} />
        </Box>

        <Box
          sx={{
            marginTop: '20px',
            display: 'flex',
            flexDirection: 'row',
            flexGrow: 1,
            gap: '20px'
          }}
        >
          <Box>
            <Typography variant="caption" color="textSecondary">
              Invoice Date
            </Typography>
            <Typography variant="body1" fontWeight={500}>
              {date}
            </Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="textSecondary">
              Period
            </Typography>
            <Typography variant="body1" fontWeight={500}>
              {period}
            </Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="textSecondary">
              Amount
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              {formatNumberToCurrency(tenant.nextinvoicepaymentvalue)}
            </Typography>
          </Box>
        </Box>

        {isPending && (
          <Button
            fullWidth
            variant="contained"
            color="primary"
            startIcon={<CheckIcon />}
            sx={{ fontWeight: 'bold' }}
          >
            Approve Invoice
          </Button>
        )}
      </Paper>

      <Box
        sx={{
          marginTop: '20px',
          display: 'flex',
          flexDirection: 'row',
          gap: '20px'
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Paper sx={{ p: 3, textAlign: 'center', bgcolor: '#F5F5F5' }} elevation={0}>
            <Typography variant="h4" fontWeight="bold">
              TODO
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Total Invoices
            </Typography>
          </Paper>
        </Box>
        <Box sx={{ flex: 1 }}>
          <Paper sx={{ p: 3, textAlign: 'center', bgcolor: '#F5F5F5' }} elevation={0}>
            <Typography variant="h4" fontWeight="bold" color="success.main">
              TODO
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Paid
            </Typography>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default NextInvoiceDetails;
